export type NameType = 'collapsing';

export const name: NameType = 'collapsing';
